import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { openLeadPopup } from "./Navbar";
import { waLink, CONTEXT_MESSAGES } from "../lib/whatsapp";
import { track } from "../lib/analytics";

export default function FomoBand() {
  return (
    <section className="relative overflow-hidden border-y border-line bg-ink py-16 lg:py-20" data-testid="fomo-band">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,69,0,0.08),transparent_60%)]" />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-8">
        <Reveal>
          <h2 className="font-display text-3xl font-bold leading-[1.05] tracking-tight sm:text-4xl">
            Your Next Customer Is <span className="text-ember">Already Searching.</span>
          </h2>
          <div className="mx-auto mt-6 max-w-2xl space-y-2 text-sm leading-relaxed text-white/55 sm:text-base">
            <p>Your competitors are already improving their online presence.</p>
            <p>Every month your website fails to convert is another month of missed enquiries.</p>
            <p>Turn your website into a 24/7 lead-generation channel — before they do.</p>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <button
              data-testid="fomo-cta-btn"
              onClick={() => { track("cta_click", { location: "fomo_band" }); openLeadPopup(); }}
              className="group flex items-center gap-2 rounded-full bg-ember px-7 py-4 font-display text-sm font-bold uppercase tracking-wider transition-colors hover:bg-ember-hover"
            >
              Get My Free Growth Review
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href={waLink(CONTEXT_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fomo-whatsapp-btn"
              onClick={() => track("whatsapp_click", { location: "fomo_band" })}
              className="flex items-center gap-2 rounded-full border border-[#25D366]/50 px-7 py-4 font-display text-sm font-bold uppercase tracking-wider text-[#25D366] transition-colors hover:bg-[#25D366]/10"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp Grotech Web
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
